import { i18n } from 'vue-infra';
import { filter, has, sortBy } from 'lodash';
import { getMetricScoreWithUnit as _getMetricScoreWithUnit } from '@core/utils/utils';
import eventBusEmitter from '@core/event-bus/EventBusEmitter';
import {
  AGENT_STATUSES_LABELS_I18N_KEYS,
  CONVERSATION_STATUSES_CLASSES_MAP,
  METRIC_TYPE,
  USAGE_MEASUREMENT_ID,
  DEFAULT_THEME,
  PLACEHOLDER_SETTINGS,
  GRAPH_THEMES_SETTINGS,
} from '@core/config/Consts';

export const getMetricScoreWithUnit = (score, unitType) => _getMetricScoreWithUnit(score, unitType);

export const isDurationMetric = type => type === METRIC_TYPE.DURATION;

export const isArrayMetric = type => type === METRIC_TYPE.ARRAY;

export const getConversationStatusClass = status => CONVERSATION_STATUSES_CLASSES_MAP[status];

export const orderedCollection = (collection, orderKey) =>
  sortBy(filter(collection, item => item[orderKey] !== undefined), orderKey);

/**
 * Single API returns agentCurrentStatusReason as string i.e. Coffee Break instead of statusReasonId - 383828282
 * We check if there is statusReason and return either the statusReason string or status after i18n translation
 * Code before Single API is preserved in comments
 * @param statusReason {String|Number} - status reason ID or Status Reason text
 * @param status {String} - agent status - ONLINE/AWAY/OFFLINE
 * @return {string|*}
 */
export const getStatusReasonText = (statusReason, status) => {
  if (statusReason) {
    return statusReason;
  }
  return status ? i18n.t(`amd:${AGENT_STATUSES_LABELS_I18N_KEYS[status]}`) : '';

  // let result = !isNil(status) ? i18n.t(`amd:${AGENT_STATUSES_LABELS_I18N_KEYS[status]}`) : '';
  // if (!isNil(statusReasonId)) {
  //   const statusReasonNumber = Number(statusReasonId);
  //   const statusReason = find(statusReasons, reason => reason.id === statusReasonNumber);
  //   if (!isNil(statusReason)) {
  //     result = statusReason.text;
  //   }
  // }
  // return result;
};

export const sendReportingSDE = (event, sdeParams, sdeCredentials) => {
  const basicUsageSde = {
    accountId: sdeCredentials.accountId,
    userId: sdeCredentials.userId,
    event,
  };
  const usageSde = JSON.stringify(Object.assign(basicUsageSde, sdeParams));
  if (window.lpTag && window.lpTag.sdes) {
    window.lpTag.sdes.push({ type: 'service', service: { topic: usageSde, category: USAGE_MEASUREMENT_ID } });
  }
};

export const getPlaceholderSettings = (activeTheme) => {
  let placeholderSettings = PLACEHOLDER_SETTINGS[DEFAULT_THEME];
  if (has(PLACEHOLDER_SETTINGS, activeTheme) && activeTheme !== DEFAULT_THEME) {
    placeholderSettings = PLACEHOLDER_SETTINGS[activeTheme];
  }
  return placeholderSettings;
};

export const getGraphThemeSettings = (activeTheme) => {
  let graphThemeSettings = GRAPH_THEMES_SETTINGS[DEFAULT_THEME];
  if (has(GRAPH_THEMES_SETTINGS, activeTheme) && activeTheme !== DEFAULT_THEME) {
    graphThemeSettings = GRAPH_THEMES_SETTINGS[activeTheme];
  }
  return graphThemeSettings;
};

export const emitter = () => eventBusEmitter;
